import React from "react";
import { Star, Clock, Plus, Minus } from "lucide-react";
import { rupee } from "../../lib/format";
import { useCart } from "../../context/CartContext";
import { RestaurantLogo } from "../RestaurantLogo";

export function VegBadge({ type }) {
  return <span className={type === "veg" ? "veg-dot" : "nonveg-dot"} title={type} />;
}

export function ItemCard({ item, onAdd, showRestaurant = false }) {
  const { qtyForItem, changeQty, items, addItem } = useCart();
  const qty = qtyForItem(item.id);
  const hasOptions = (item.variants?.length || 0) > 0 || (item.addons?.length || 0) > 0;

  const handleAdd = () => {
    if (hasOptions) onAdd(item);
    else addItem(item);
  };

  const decrement = () => {
    const line = items.find((l) => l.item_id === item.id);
    if (line) changeQty(line.key, -1);
  };
  const increment = () => {
    if (hasOptions) { onAdd(item); return; }
    addItem(item);
  };

  return (
    <div className="card-surface rounded-2xl overflow-hidden flex flex-col animate-fadeup"
         data-testid={`item-card-${item.id}`}>
      <div className="relative h-32 w-full overflow-hidden">
        <img src={item.image} alt={item.name}
             className="h-full w-full object-cover transition-transform duration-500 hover:scale-110" />
        {item.is_bestseller && (
          <span className="absolute top-2 left-2 text-[10px] font-bold px-2 py-0.5 rounded-full gold-gradient text-slate-950">
            BESTSELLER
          </span>
        )}
      </div>
      <div className="p-3 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-1">
          <VegBadge type={item.food_type} />
          {showRestaurant && (
            <div className="flex items-center gap-1.5 min-w-0">
              <RestaurantLogo name={item.restaurant_name} logo={item.restaurant_logo} size={16} />
              <span className="text-[10px] text-amber-300/90 font-medium truncate">{item.restaurant_name}</span>
            </div>
          )}
        </div>
        <h4 className="font-semibold text-sm text-slate-100 leading-tight line-clamp-2">{item.name}</h4>
        <div className="flex items-center gap-3 mt-1 text-[11px] text-slate-400">
          <span className="flex items-center gap-1"><Star size={11} className="text-amber-400 fill-amber-400" />{item.rating}</span>
          <span className="flex items-center gap-1"><Clock size={11} />{item.prep_time}m</span>
        </div>
        <div className="flex items-center justify-between mt-auto pt-3">
          <span className="font-display font-bold text-base text-slate-100">{rupee(item.price)}</span>
          {qty > 0 ? (
            <div className="flex items-center gap-2 gold-gradient rounded-lg px-1 py-1" data-testid={`qty-stepper-${item.id}`}>
              <button onClick={decrement} className="text-slate-950 px-1.5" data-testid={`dec-${item.id}`}><Minus size={14} /></button>
              <span className="text-slate-950 font-bold text-sm w-4 text-center">{qty}</span>
              <button onClick={increment} className="text-slate-950 px-1.5" data-testid={`inc-${item.id}`}><Plus size={14} /></button>
            </div>
          ) : (
            <button onClick={handleAdd}
              className="gold-btn rounded-lg px-3 py-1.5 text-xs flex items-center gap-1"
              data-testid={`add-item-${item.id}`}>
              <Plus size={14} /> ADD
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
